import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  AfterViewInit,
  ElementRef
} from '@angular/core';
import { FacadeService } from '../../../services/facade.service';
import { debounceTime, distinctUntilChanged, filter, tap } from 'rxjs/operators';
import { Address, AddressStreet, Option } from '../../models/components/Address';
import { MatSelectChange } from '@angular/material/select';
import { Subscription } from 'rxjs/internal/Subscription';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { Country } from '@app/shared/models/components';

@Component({
  selector: 'company-profile-branch-address',
  templateUrl: './company-profile-branch-address.component.html',
  styleUrls: ['./company-profile-branch-address.component.scss']
})

export class CompanyProfileBranchAddressComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

  areas: Option[] = [];
  governorates: Option[] = [];
  blocks: Option[] = [];
  streets: Option[] = [];

  address: Address;
  locale: string;

  @Output() onAddressChanges: EventEmitter<Address> = new EventEmitter<Address>();
  @Output() validAddress: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() country: EventEmitter<Country> = new EventEmitter<Country>();

  @ViewChild('building', { static: true }) building: ElementRef;
  @ViewChild('floor', { static: true }) floor: ElementRef;
  @ViewChild('flat', { static: true }) flat: ElementRef;



  @Input() addressToReplace: Address;
  @Input() index: number = 0;
  @Input() isCountry: boolean = false;
  @Input() isRemoveLocalCountry: boolean = false;
  @Input() disableAddress: boolean = false;
  @Input() validateAddress: boolean = false;
  @Input() isPACI: boolean = false;
  @Input() col: string = 'col-md-4';
  @Input() disableCountry: boolean = false;
  @Input() buildingNoRequired: boolean = false;
  @Input() floorNoRequired: boolean = false;
  @Input() flatNoRequired: boolean = false;

  @Input() previousCountryId: number;
  @Input() countries: Country[] = [];

  selectedCountry: Option;
  selectedArea: Option;
  selectedGovernorate: Option;
  selectedBlock: Option;
  subscriptions = new Subscription();
  showFreeFormAddress: boolean = false;

  /**
   * 
   * @param facadeService 
   */
  constructor(private facadeService: FacadeService) {
    this.subscriptions.add(this.facadeService.sharedFacadeService.languageService.language.subscribe(lngCode => {
      this.locale = lngCode;
    }));
    this.address = { country: '', governorate: '', area: '', block: '', building: '', flat: '', floor: '', street: '' };
    this.addressToReplace = { country: '', governorate: '', area: '', block: '', building: '', flat: '', floor: '', street: '' };
  }

  ngOnInit() {    
    if (!this.address) {
      this.address = { country: '', governorate: '', area: '', block: '', building: '', flat: '', floor: '', street: '' };
    }

    if (!this.addressToReplace) {
      this.addressToReplace = { country: '', governorate: '', area: '', block: '', building: '', flat: '', floor: '', street: '' };
    }

    if (!this.isCountry) {
      this.listGovernorates();
    }
  }

  ngAfterViewInit() {
    fromEvent(this.building?.nativeElement, 'keyup').pipe(filter(Boolean), debounceTime(500), distinctUntilChanged(),
      tap(text => {
        this.validAddress.emit(true);
        if ((!this.checkString(this.address.building))  && (this.buildingNoRequired)) {
          this.validAddress.emit(false);
        }

        this.onAddressChanges.emit(this.address);
        // }
      })).subscribe();

      fromEvent(this.floor?.nativeElement, 'keyup').pipe(filter(Boolean), debounceTime(500), distinctUntilChanged(),
      tap(text => {
        this.validAddress.emit(true);
        if (( (!this.checkString(this.address.floor)) ) && ( this.floorNoRequired )) {
          this.validAddress.emit(false);
        }

        this.onAddressChanges.emit(this.address);
        // }
      })).subscribe();

      fromEvent(this.flat?.nativeElement, 'keyup').pipe(filter(Boolean), debounceTime(500), distinctUntilChanged(),
      tap(text => {
        this.validAddress.emit(true);
        if (((!this.checkString(this.address.flat))) && (this.flatNoRequired)) {
          this.validAddress.emit(false);
        }

        this.onAddressChanges.emit(this.address);
        // }
      })).subscribe();
  }

  /**
   * check string length
   * 
   * 
   * @param string 
   */
  checkString(string: string): boolean {
    return String(string) && String(string).trim().length > 0 ? true : false;
  }

  /**
   * areas
   * 
   * 
   */
  listAreas() {
    if (!this.addressToReplace) {
      this.blocks = [];
      this.streets = [];

      this.address.block = '';
      this.address.street = '';
    }

    this.subscriptions.add(this.facadeService.addressService.areas.subscribe((areas: Option[]) => {
      this.areas = areas;
    }));
  }

  listGovernorates() {
    this.subscriptions.add(this.facadeService.addressService.governorates.subscribe((governorates: Option[]) => {
      this.governorates = governorates;

      const value = this.filterValue(this.governorates, this.address.governorate)
      this.address.previousGovernorate = value;
      this.address.governorate = value;
    }));
  }

  /**
   * blocks via area
   * 
   * 
   */
  listBlocksByArea(area: string) {
    if (!this.addressToReplace) {
      this.streets = [];
      this.address.street = '';
    }

    this.subscriptions.add(this.facadeService.addressService.getBlocksByArea(area).subscribe((blocks: Option[]) => {
      this.blocks = blocks;

      const value = this.filterValue(this.blocks, this.address.block);
      this.address.previousBlock = value;
      this.address.block = value;
    }));
  }

  /**
   * areas via governorate
   * 
   * 
   */
  listAreasByGovernorate(governorate: string) {
    this.subscriptions.add(this.facadeService.addressService.areasByGovernorate(governorate).subscribe((areas: Option[]) => {
      this.areas = areas;

      const value = this.filterValue(this.areas, this.address.area);
      this.address.previousArea = value;
      this.address.area = value;
    }));
  }

  /**
   *  blocks via area / block / governate
   * 
   * 
   * @param addressStreet 
   */
  listStreets(addressStreet: AddressStreet) {
    if (addressStreet && addressStreet.areaId && addressStreet.blockName) {
      this.subscriptions.add(this.facadeService.addressService.getStreetsByBlock(addressStreet).subscribe((streets: Option[]) => {
        this.streets = streets;
        this.address.previousStreet = this.filterValue(this.streets, this.address.street);
        this.address.street = this.filterValue(this.streets, this.address.street);
      }));
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.addressToReplace) {
      this.address = changes.addressToReplace.currentValue;
      if (this.address && this.checkString(this.address.governorate)) {
        this.listAreasByGovernorate(this.address.governorate);
      }

      if (this.address && this.checkString(this.address.area)) {
        this.listBlocksByArea(this.address.area);
      }

      if (this.address && this.checkString(this.address.block)) {
        this.listStreets({ areaId: this.address.area, blockName: this.address.block });
      }
    }

    if (changes && changes.disableAddress) {
      this.disableAddress = changes.disableAddress.currentValue;
    }

    if (changes && changes.validateAddress) {
      this.validateAddress = changes.validateAddress.currentValue;
    }

    if (changes && changes.isCountry) {
      this.isCountry = changes.isCountry.currentValue;
    }

    if (changes && changes.isRemoveLocalCountry) {
      this.isRemoveLocalCountry = changes.isRemoveLocalCountry.currentValue;
    }

    if (changes && changes.buildingNoRequired) {
      this.buildingNoRequired = changes.buildingNoRequired.currentValue;
    }

    if (changes && changes.floorNoRequired) {
      this.floorNoRequired = changes.floorNoRequired.currentValue;
    }

    if (changes && changes.flatNoRequired) {
      this.flatNoRequired = changes.flatNoRequired.currentValue;
    }

    if (changes && changes.disableCountry) {
      this.disableCountry = changes.disableCountry.currentValue;
    }

    if (changes && changes.previousCountryId) {
      this.previousCountryId = changes.previousCountryId.currentValue;
    }
  }

  /**
   * select area / block / street according to type
   * 
   * 
   * @param option 
   */
  onSelectOption(option: MatSelectChange, type: string): void {
    const value = option.value;
    if (type == 'governorate') {
      this.areas = [];
      this.blocks = [];
      this.streets = [];
      this.address.area = null;
      this.address.block = null;
      this.address.street = null;

      this.address.governorate = value;
      this.listAreasByGovernorate(value);
    }

    if (type == 'area') {
      this.blocks = [];
      this.streets = [];
      this.address.block = null;
      this.address.street = null;

      this.address.area = value;
      this.listBlocksByArea(value);
    }

    if (type == 'block') {
      this.streets = [];
      this.address.street = null;

      this.address.block = value;
      this.listStreets({ areaId: this.address.area, blockName: value });
    }

    if (type == 'street') {
      this.address.street = value;
      // if (this.checkString(this.address.area) && this.checkString(this.address.block) && this.checkString(this.address.street) && this.checkString(this.address.building)) {
      // this.address.fullAddress = `${this.locale == 'en' ? 'block' : 'قطعة'} ${this.address.block}, ${this.locale == 'en' ? 'building' : 'عمارة'} ${this.address.building} ${this.locale == 'en' ? 'street' : 'شارع'} ${this.address.street}, ${this.address.area}`;
      // }
    }

    this.onAddressChanges.emit(this.address);

    if (this.validateAddress && (!(this.address.governorate && this.address.area))) {
      this.validAddress.emit(false);
    } else if ((this.buildingNoRequired && this.floorNoRequired && this.flatNoRequired) && ((!this.address.building) && (!this.address.flat) && (!this.address.floor))) {
      this.validAddress.emit(false);
    } else {
      this.validAddress.emit(true);
    }
  }
  setIsValid() {
    this.validAddress.emit(true);

  }
  onChangePACI(paciNumber: number) {
    if (paciNumber.toString().trim().length > 0) {

      this.subscriptions.add(this.facadeService.addressService.getAddressViaPACI(paciNumber).subscribe((res: { location: Address }) => {
        const address = res.location;

        this.address.governorate = address.governorate;
        this.listAreasByGovernorate(address.governorate);

        this.address.area = address.area;
        this.listBlocksByArea(address.area);

        this.address.block = address.block;
        this.listStreets({ areaId: address.area, blockName: address.block });

        this.address.street = address.street;
        this.address.building = address.building;
        this.address.floor = address.floor;
        this.address.flat = address.flat;

        this.onAddressChanges.emit(this.address);
        this.validAddress.emit(true);
      }));
    }
  }

  filterValue(array: Option[], value: string): string {
    var selectedValue: string;

    array.forEach((element: Option) => {
      if (element.id == String(value).trim()) {
        selectedValue = element.id as string;
      }
    });

    return selectedValue;
  }

  onCountry(country: Country) {
    this.showFreeFormAddress = false;

    if(!(country.code === '965' && country.id === 121)){
      this.showFreeFormAddress = true;
    }

    this.country.emit(country);
  }

  onGovernorates(governorates: Option[]) {
    this.governorates = governorates;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}